import { useTranslation } from 'react-i18next';
import { NON_NAVIGABLE_WIDGETS } from '@/consts/widget';
import { Section } from '@/types/generic';
import { ConfigDisplaySettings } from '@/types/userConfigs';
import { WidgetVisType } from '@/types/widget';

export const useWidgetNavigationPath = (
  entity: Section,
  entityId: number | null,
  vis: WidgetVisType,
  metricKey?: string,
  radarTemplateId?: number,
  displaySettings?: Partial<ConfigDisplaySettings>,
) => {
  const {
    i18n: { language },
  } = useTranslation();

  if (NON_NAVIGABLE_WIDGETS.includes(vis)) return '';

  const metricKeyParam = metricKey ? `&metricKey=${metricKey}` : '';

  const displaySettingsParam = displaySettings
    ? Object.entries(displaySettings)
        .map(([key, value]) => `&${key}=${value}`)
        .join('')
    : '';

  const getVisNavigationPath = () => {
    if (vis === 'squad') return 'squad';

    if (vis === 'radar') {
      const radarTemplateParam = radarTemplateId ? `?radarTemplate=${radarTemplateId}` : '';
      return `radar${radarTemplateParam}`;
    }

    return `vis?vis=${vis}${displaySettingsParam}`;
  };

  const getPageNavigationPath = () => {
    if (entity === 'dataLocker') {
      return `data-locker/events?displayMode=vis&vis=${vis}`;
    }

    return `${entity}/${entityId}/${getVisNavigationPath()}`;
  };

  return `/${language}/${getPageNavigationPath()}${metricKeyParam}`;
};
